import { render, staticRenderFns } from "./OrderDetailUnpay.vue?vue&type=template&id=05af0936&scoped=true"
import script from "./OrderDetailUnpay.vue?vue&type=script&lang=js"
export * from "./OrderDetailUnpay.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailUnpay.vue?vue&type=style&index=0&id=05af0936&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af0936",
  null
  
)

export default component.exports